import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  open({params: {src, id}}) {
    if (!src || !id) {
      console.error('Turbo Frame Modal: Missing src or id parameter.')
      return
    }

    const dialog = document.createElement('dialog')
    dialog.id = `dialog_${id}`
    dialog.classList = 'fixed inset-0 max-h-full max-w-full size-full z-99 overflow-y-auto bg-transparent backdrop:bg-transparent'
    dialog.innerHTML = `<turbo-frame src="${src}" id="${id}"></turbo-frame>`

    document.body.appendChild(dialog)
    dialog.showModal()
  }
}
